module.exports = __webpack_public_path__ + "static/media/print.87330ca7.svg";